/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ConfigurationLocationComponent } from '../../components/workspace/configuration-location/configuration-location.component';
import { GlobalConstants } from '../../constants/global-constants';
import { ConfigurationLocationInfo } from '../../models/configuration-location-model';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class ConfigurationLocationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = ConfigurationLocationComponent;
    sysquePopupConfig.data = new ConfigurationLocationInfo();
    (sysquePopupConfig.data as ConfigurationLocationInfo).pathLabel = GlobalConstants.PathLabel;
    (sysquePopupConfig.data as ConfigurationLocationInfo).applyName = GlobalConstants.ApplyButton;
    (sysquePopupConfig.data as ConfigurationLocationInfo).revertName = GlobalConstants.RevertButton;
    sysquePopupConfig.width = 493;
    sysquePopupConfig.height = 300;
    sysquePopupConfig.componentTitle = GlobalConstants.ConfigurationLocationDialogName;
  }
}
